/* FABEL — cart-drawer.js : AJAX cart drawer, line updates, section rendering. */
(function () {
  'use strict';

  const FABEL = window.FABEL;
  const Drawer = FABEL && FABEL.FabelDrawer;
  if (!Drawer) return;

  /* Which server-rendered sections currently live in the DOM. */
  function sectionTargets() {
    return Array.from(document.querySelectorAll('[data-section-replace]')).map((el) =>
      el.getAttribute('data-section-replace')
    );
  }

  FABEL.cart = FABEL.cart || {};

  FABEL.cart.sectionsParam = function () {
    const ids = sectionTargets();
    return ids.length ? ids.join(',') : 'cart-drawer';
  };

  /* Replace every [data-section-replace] container with its freshly rendered HTML. */
  FABEL.cart.render = function (sections) {
    if (!sections) return;
    Object.keys(sections).forEach((id) => {
      const target = document.querySelector(`[data-section-replace="${id}"]`);
      if (!target || typeof sections[id] !== 'string') return;
      const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
      const source = parsed.querySelector(`[data-section-replace="${id}"]`);
      if (source) {
        target.innerHTML = source.innerHTML;
        if (source.hasAttribute('data-cart-count')) {
          target.setAttribute('data-cart-count', source.getAttribute('data-cart-count'));
        }
      }
    });
    FABEL.cart.syncCount();
    FABEL.publish('cart:updated', {});
    if (FABEL.initReveal) FABEL.initReveal();
  };

  /* Header bubble + a11y text are driven by the rendered cart markup. */
  FABEL.cart.syncCount = function () {
    const source = document.querySelector('[data-cart-count]');
    if (!source) return;
    const count = parseInt(source.getAttribute('data-cart-count') || '0', 10);
    document.querySelectorAll('[data-cart-bubble]').forEach((bubble) => {
      bubble.textContent = count > 99 ? '99+' : count;
      bubble.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-bubble-text]').forEach((el) => {
      const template = el.getAttribute('data-cart-bubble-text');
      el.textContent = template.replace('[count]', count);
    });
  };

  FABEL.cart.open = function (opener) {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open(opener);
  };

  /* Add to cart — returns the parsed response so callers can handle errors. */
  FABEL.cart.add = function (formData) {
    formData.append('sections', FABEL.cart.sectionsParam());
    formData.append('sections_url', window.location.pathname);

    return fetch(`${FABEL.routes.cart_add_url}`, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) return { error: data.description || data.message || FABEL.strings.cartError };
        FABEL.cart.render(data.sections);
        return { ok: true, item: data };
      })
      .catch(() => ({ error: FABEL.strings.cartError }));
  };

  FABEL.cart.change = function (body) {
    return fetch(`${FABEL.routes.cart_change_url}`, {
      ...FABEL.fetchConfig('json'),
      body: JSON.stringify({
        ...body,
        sections: FABEL.cart.sectionsParam(),
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status !== 200) {
          return { error: data.description || data.message || FABEL.strings.cartError, data };
        }
        FABEL.cart.render(data.sections);
        return { ok: true, data };
      })
      .catch(() => ({ error: FABEL.strings.cartError }));
  };

  /* ------------------------------------------------------------- drawer -- */
  class CartDrawer extends Drawer {
    connectedCallback() {
      super.connectedCallback();
      FABEL.cart.syncCount();
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  /* -------------------------------------------------------- line updates -- */
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-line-quantity]');
        if (!input) return;
        const quantity = Math.max(0, parseInt(input.value, 10) || 0);
        this.updateLine(input.getAttribute('data-line-key'), quantity, input.closest('[data-cart-line]'));
      });

      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-line-remove]');
        if (!remove) return;
        event.preventDefault();
        this.updateLine(remove.getAttribute('data-line-key'), 0, remove.closest('[data-cart-line]'));
      });
    }

    setBusy(line, busy) {
      (line || this).classList.toggle('facets-loading', busy);
    }

    updateLine(key, quantity, line) {
      if (!key) return;
      this.setBusy(line, true);
      FABEL.cart.change({ id: key, quantity }).then((result) => {
        this.setBusy(line, false);
        if (result && result.error) {
          const target = document.querySelector(`[data-cart-line-error="${key}"]`);
          if (target) target.textContent = result.error;
          FABEL.announce(result.error);
        } else {
          FABEL.announce(FABEL.strings.cartUpdated);
        }
      });
    }
  }
  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  /* ---------------------------------------------------------- cart note -- */
  document.addEventListener('change', (event) => {
    const note = event.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(FABEL.routes.cart_update_url, {
      ...FABEL.fetchConfig('json'),
      body: JSON.stringify({ note: note.value })
    });
  });

  document.addEventListener('DOMContentLoaded', FABEL.cart.syncCount);
})();
